<template>
  <div>
    <el-dialog
      :visible.sync="dialsetting"
      width="80%"
      title="批量设置">
      <div v-for="(item,index) in settingary" :key="item.name"  class="settcheckbox">
        <div>{{item.name}} 
          <img style="width:20px;margin-left:15px" @click="batch(index)" src="../../../assets/images/update.png"/>
        </div>
        <div>
          <el-checkbox  v-model="item.isCheck" :indeterminate="item.isIndeterminate" @change="handleCheckAllChange(item.isCheck,index)">全选</el-checkbox>
          <el-checkbox-group v-model="item.checkedData" @change="handleCheckedCitiesChange(item.checkedData, index)" >
            <el-checkbox v-for="k in item.coinary" :label="k" :key="k.coinType">{{k.coinType}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="batchdial"
      width="40%"
      title="批量设置">
      <div class="batchcoin">
        <span>币种</span>
        <span>{{seleCoin.length}}个</span>
      </div>
      <div class="coinbox">
        <span v-for="item in seleCoin" :key="item.id">{{item.coinType}}</span>
      </div>
      <div class="batchcoin">
        <span>提现成本</span>
        <input type="text" v-model="cost" onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''" placeholder="请输入成本"/>
      </div>
      <button @click='submit'>提交</button>
    </el-dialog>
  </div>
</template>
<script>
import '../store.js';
// import Pagination from "../../../components/pagination";
import { mapState,mapActions } from 'vuex';
import {SHARE_TYPE} from '../constant.js'
 const cityOptions = ['上海', '北京', '广州', '深圳','安徽','四川','杭州','福建'];
export default {
  name: "batchsetting",
  data() {
    return {
      dialsetting:false,
      batchdial:false,
      checkAll: false,
      checkedCities: [],
      cities: cityOptions,
      isIndeterminate: false,
      settingary:[],
      cost:null,
      seleCoin:[],
      seleindex:10,
      pagation:{
        page:1,
        size:10
      }
    };
  },
  computed: {
    ...mapState('withdrawal', ['pagination','coinGroup']),
  },
  created(){
  },
  methods: {
     ...mapActions('withdrawal', ['getCoinGroup','batchUpdate','getCoinWithdrawFeeConfigList']),
    batch(index){
      let str = this.checkedCities;
      let sele = this.settingary[index]
      let ary=[]
      for(let i in str){
        if(str[i].groupName == sele.name){
          ary.push(str[i])
        }
      }
      this.seleCoin = ary;
      this.batchdial = true;
    },
    submit(){
      let ary = [];
      for(let i in this.seleCoin){
       ary.push(this.seleCoin[i].id)
        
      }
      this.batchUpdate({cost:this.cost,ids:ary.join(',')})
      this.getCoinWithdrawFeeConfigList({
        ...this.pagation,
        coinType:''
      });
      this.dialsetting = false;
      this.batchdial = false
    },
    showData(data,pagation) {
      let ary = []
      this.pagation = pagation;
      for(let i in data){
        let obj = {}
        obj.name = i
        obj.coinary = data[i]
        obj.isCheck = false;
        obj.isIndeterminate = true;
        obj.checkedData = [];
        ary.push(obj)
        this.dialsetting = true
      }
      this.settingary = ary
    },
     checkTitle(val, index) {
      let arr = [];
      const re = this.data[index].children;
     
    },
    handleCheckAllChange(val,index) {
      let arr = [];
      const re = this.settingary[index].coinary;
       //全选
      if (val) {
        for (let i = 0; i < re.length; i++) {
          arr[i] = re[i];
        }
      }
      this.settingary[index].checkedData = arr;
      this.settingary[index].isIndeterminate = false;
      this.checkedCities = this.settingary[index].coinary;
    },
    handleCheckedCitiesChange(val, index) {
      this.checkedCities = val;
      let checkedCount = val.length;
      this.settingary[index].isCheck = checkedCount === this.settingary[index].coinary.length;
      this.settingary[index].isIndeterminate =
      checkedCount > 0 && checkedCount < this.settingary[index].coinary.length;
    },
  },
  watch: {
  },
  filters: {
  },
};
</script>
<style lang="less" scoped>
    .btn-wrap {
        text-align: center;
    }
    .el-checkbox{
  width: 100px;
  margin: 5px;
}
.settcheckbox{
  margin-bottom: 20px;
  >div:nth-child(1){
    img{
      cursor: pointer;
    }
  }
  >div:nth-child(2){
    margin-top: 20px;
  }
}
.batchcoin{
  display: flex;
  justify-content: space-between;
  height: 50px;
  line-height: 50px;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
}
.coinbox{
  >span{
    display: inline-block;
    width: 100px;
    margin: 10px 0;
  }
}
input,button{
  border: none;
  list-style: none;
  outline: none;
  text-align: right;
}
button{
    width: 100%;
    height: 50px;
    text-align: center;
    background: #466fe1;
    color: white;
    font-size: 16px;
    cursor: pointer;
    margin-top: 30px;
  }
</style>
